<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                    <div class="card-header card-header-info">
                        <h4 class="card-title ">Rincian Mitra</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Nama</label>
                                    <p class="bmd-label-floating mb-0" >{{data.params.nama}}</p>
                                    <p class="bmd-label-floating mb-0" >{{data.params.wa}}</p>
                                </div>
                                <div class="form-group">
                                    <label class="bmd-label-floating">Alamat</label>
                                    <p class="bmd-label-floating mb-0" >{{data.params.alamat}}</p>
                                </div>
                                <div class="form-group">
                                    <label class="bmd-label-floating">Harga</label>
                                    <p class="bmd-label-floating mb-0" >{{myGlobal.ribu(data.params.ribu)}}</p>
                                </div>
                                <div class="form-group">
                                    <label class="bmd-label-floating">Tanggal Tagihan</label>
                                    <p class="bmd-label-floating mb-0" >{{data.params.tgl_tagihan}}</p>
                                </div>
                                <div class="form-group">
                                    <label class="bmd-label-floating">Bandwith</label>
                                    <p class="bmd-label-floating mb-0" v-if="data.params.bw != null">{{data.params.bw}}</p>
                                    <p class="bmd-label-floating mb-0" v-else>{{data.params.up}} mb</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            
			<div class="row">
				<div class="col-md-12">
                    <button class="btn btn-info" @click="data.historyUpgrade = true">
                        History Upgrade
                    </button>
                    <button class="btn btn-success" @click="data.historyUpgrade = false">
                        History Bayar
                    </button>

				</div>
			</div>
            
            <div class="row">
                <div class="col-md-12">
                    <div class="card" v-if="data.historyUpgrade">
                        <div class="card-header card-header-info">
                            <div class="row">
                                <div class="col-md-6">
                                    <h4 class="card-title ">History Upgrade</h4>
                                </div>
                                <div class="col-md-6" v-show="false">
                                    <h2 class="card-title text-right">{{data.filtered}}</h2>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                            <table class="table">
                                <thead class=" text-info">
                                <th width="40px">No.</th>
                                <th>Bandwith Awal</th>
                                <th>Bandwith Upgrade</th>
                                <th>Tagihan</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(u, index) in rincian.data.list">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span v-if="u.bw != null">{{ u.bw }} mb</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td>
                                            <span v-if="u.up != null">{{ u.up }} mb</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td>{{u.jam}}</br>{{ myGlobal.tglIndo(u.tanggal) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>

                    <div class="card" v-else>
                        <div class="card-header card-header-success">
                            <div class="row">
                                <div class="col-md-6">
                                    <h4 class="card-title ">History Bayar</h4>
                                </div>
                                <div class="col-md-6" v-show="false">
                                    <h2 class="card-title text-right">{{data.filtered}}</h2>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                            <table class="table">
                                <thead class=" text-info">
                                    <th width="40px">No.</th>
                                    <th>Bulan Bayar</th>
                                    <th>Total</th>
                                    <th>Sisa Bayar</th>
                                    <th>Bandwith</th>
                                    <th>Tanggal Bayar</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(u, index) in rincian.data.listBayar">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ myGlobal.BulanOnly(u.bulan_bayar) }}</td>
                                        <td>{{ myGlobal.ribu(u.total) }}</td>
                                        <td class="text-warning"><strong>{{ myGlobal.ribu(u.sisa_bayar) }}</strong></td>
                                        <td>
                                            <span v-if="u.bw != null">{{ u.bw }} mb</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td>{{u.jam}}</br>{{ myGlobal.tglIndo(u.tanggal_bayar) }}</td>
                                    </tr>
                                </tbody>
                                <tbody v-show="rincian.data.listBayar.length == 0">
                                    <td></td>
                                    <td>Tidak ada Data</td>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
	const data = reactive({
        params: '',
        historyUpgrade: true
    })

	const rincian = {
      	data: reactive({
            list: [],
            listBayar: []
      	}),
		get() {
			var datac = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
                mid: data.params.mid,
        	};
				
			var apiUrl = inter.MitraBw();
			myGlobal.call(datac,apiUrl).then(x => {
				if (x.status == true) {
                    rincian.data.list = x.data
				} else {
					//alert(x.pesan);
				}
			})
		},
		getBayar() {
			var datac = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
                mid: data.params.mid,
        	};
				
			var apiUrl = inter.MitraHistoryBayar();
			myGlobal.call(datac,apiUrl).then(x => {
				if (x.status == true) {
                    rincian.data.listBayar = x.data
				} else {
					//alert(x.pesan);
				}
			})
		}
    }
    return {
      data,
      myGlobal,
      rincian
    }

  },
  mounted () {

    var param = this.$route.params;
    this.data.params = param.data;

    //console.log(JSON.stringify(this.data.params));

    this.rincian.get();
    this.rincian.getBayar();
  }
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mitra/detail.vue